import React from 'react';
import {
  Box,
  Container,
  Grid,
  makeStyles,
  withStyles,
  Select,
  MenuItem,
  FormControl,
  FormLabel,
  InputLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@material-ui/core';
const textStyles = makeStyles({});

import TextField from '@material-ui/core/TextField';

import Question from '../question/Question';

const Namecard = ({
  daten,
  cardcontent,
  handleUpdate,
  url,
  country,
  hovercolor,
}) => {
  const useStyles = makeStyles({
    ccsLabelFocused: {
      color: hovercolor + ' !important',
    },
    formLabelFocused: {
      color: hovercolor + ' !important',
    },
    cssFocused: {
      boxShadow: 'none',
      '& .MuiInput-input': {
        border: '1px ' + hovercolor + ' solid !important',
        borderBottom: '2px ' + hovercolor + ' solid !important',
        boxShadow: 'none',
      },
    },
    underline: {
      '&::after': {
        border: '1px solid ' + hovercolor + ' !important',
      },
    },
    formControl: {
      minWidth: 100,
    },
  });

  const check2 = str => {
    if (str == undefined) {
      return 0;
    }

    if (str.length >= 2) {
      let uniq = '';

      for (let i = 0; i < str.length; i++) {
        if (uniq.includes(str[i]) === false) {
          uniq += str[i];
        }
      }

      if (uniq.length < 2) {
        return 0;
      } else {
        return 1;
      }
    } else {
      return 0;
    }
  };

  let cardID =
    daten['chain'].length > 0
      ? daten['chain'][daten['chain'].length - 1].toString()
      : daten['chain'][0].toString();
  let step = daten['chain'].length;
  'anrede' in daten['info'][cardID]
    ? 0
    : (daten['info'][cardID]['anrede'] = -1); //Create Dict in Info if not exists
  'name' in daten['info'][cardID] ? 0 : (daten['info'][cardID]['name'] = ''); //Create Dict in Info if not exists
  const handleChange = e => {
    daten['info'][cardID]['anrede'] = e.target.value;
    if (
      daten['info'][cardID]['anrede'] != -1 &&
      daten['info'][cardID]['vorname'] != '' &&
      daten['info'][cardID]['nachname'] != '' &&
      daten['info'][cardID]['telefon'] != '' &&
      daten['info'][cardID]['telefon']?.length >= 7 &&
      daten['info'][cardID]['vorname'] != undefined &&
      daten['info'][cardID]['nachname'] != undefined &&
      daten['info'][cardID]['telefon'] != undefined
    ) {
      daten['info'][cardID]['weiterButtonAllow'] = 1;
    } else {
      daten['info'][cardID]['weiterButtonAllow'] = 0;
    }
    handleUpdate(daten);
  };
  const handleChangeName = (e, typ) => {
    if (typ == 'telefon') {
      const re = /^[0-9\b+() -/]+$/;

      if (e.target.value === '' || re.test(e.target.value)) {
        daten['info'][cardID][typ] = e.target.value;
      }
    } else {
      daten['info'][cardID][typ] = e.target.value;
    }

    if (
      daten['info'][cardID]['anrede'] != -1 &&
      check2(daten['info'][cardID]['vorname']) &&
      check2(daten['info'][cardID]['nachname']) &&
      daten['info'][cardID]['telefon'] != '' &&
      daten['info'][cardID]['vorname'] != undefined &&
      daten['info'][cardID]['nachname'] != undefined &&
      daten['info'][cardID]['telefon'] != undefined
    ) {
      daten['info'][cardID]['weiterButtonAllow'] = 1;
    } else {
      daten['info'][cardID]['weiterButtonAllow'] = 0;
    }

    for (let i = 0; i < daten['info'][cardID]['telefon']?.length - 2; i++) {
      if (!Number.isInteger(parseInt(daten['info'][cardID]['telefon'][i]))) {
        if (i == 0 && daten['info'][cardID]['telefon'][i] == '+') {
          daten['info'][cardID]['ziffernfolge'] = 0;
          daten['info'][cardID]['weiterButtonAllow'] = 1;
        } else {
          daten['info'][cardID]['weiterButtonAllow'] = 0;
          daten['info'][cardID]['ziffernfolge'] = 1;
          break;
        }
      }

      if (
        daten['info'][cardID]['telefon'][i] ==
          daten['info'][cardID]['telefon'][i + 1] &&
        daten['info'][cardID]['telefon'][i] ==
          daten['info'][cardID]['telefon'][i + 2] &&
        daten['info'][cardID]['telefon'][i] ==
          daten['info'][cardID]['telefon'][i + 3]
      ) {
        daten['info'][cardID]['weiterButtonAllow'] = 0;
        daten['info'][cardID]['ziffernfolge'] = 1;
        break;
      } else {
        daten['info'][cardID]['ziffernfolge'] = 0;
      }
    }

    handleUpdate(daten);
  };

  const classes = useStyles();

  let renderObjekt = (
    <div
      className="flex flex-col justify-center w-260px md:w-400px"
      id="namecard"
    >
      <div className="flex flex-col justify-between items-center mt-20px   ">
        <FormControl component="fieldset">
          <FormLabel
            component="legend"
            className="justify-center flex"
            classes={{
              focused: classes.formLabelFocused,
            }}
          >
            Anrede
          </FormLabel>
          <RadioGroup
            row
            aria-label="anrede"
            name="row-radio-buttons-group"
            value={daten['info'][cardID]['anrede']}
            onChange={handleChange}
            color="default"
            className={
              daten['info'][cardID]['anrede'] != 'Herr' &&
              daten['info'][cardID]['anrede'] != 'Frau' &&
              daten['info'][cardID]?.showerrors == 1
                ? 'flex justify-center border-1 border-red-600 p-2'
                : 'flex justify-center '
            }
          >
            <FormControlLabel
              value={'Herr'}
              control={<Radio color={'default'} />}
              label="Herr"
            />
            <FormControlLabel
              value="Frau"
              control={<Radio color="default" />}
              label="Frau"
            />
          </RadioGroup>
        </FormControl>

        <div className="flex items-center">
          <div className="w-360px smx:w-420px flex flex-wrap items-center justify-center p-2">
            <div className="m-2">
              <TextField
                InputProps={{
                  style: {
                    width: '160px',
                    border:
                      (check2(daten['info'][cardID]['vorname']) == 0 ||
                        daten['info'][cardID]['vorname'] == undefined) &&
                      daten['info'][cardID]?.showerrors == 1
                        ? '1px solid red'
                        : '',
                  },
                  classes: {
                    focused: classes.cssFocused,
                    underline: classes.underline,
                  },
                }}
                id="vorname"
                name="vorname"
                label="Vorname"
                value={
                  daten['info'][cardID]['vorname']
                    ? daten['info'][cardID]['vorname']
                    : ''
                }
                InputLabelProps={{
                  classes: {
                    focused: classes.ccsLabelFocused,
                  },
                }}
                onChange={e => handleChangeName(e, 'vorname')}
              ></TextField>
            </div>
            <div className="m-2">
              <TextField
                InputProps={{
                  classes: {
                    focused: classes.cssFocused,
                    underline: classes.underline,
                  },
                  style: {
                    width: '160px',
                    border:
                      (check2(daten['info'][cardID]['nachname']) == 0 ||
                        daten['info'][cardID]['nachname'] == undefined) &&
                      daten['info'][cardID]?.showerrors == 1
                        ? '1px solid red'
                        : '',
                  },
                }}
                id="nachname"
                name="nachname"
                label="Nachname"
                value={
                  daten['info'][cardID]['nachname']
                    ? daten['info'][cardID]['nachname']
                    : ''
                }
                InputLabelProps={{
                  classes: {
                    focused: classes.ccsLabelFocused,
                  },
                }}
                onChange={e => handleChangeName(e, 'nachname')}
              ></TextField>
            </div>
          </div>
        </div>
        <TextField
          InputProps={{
            style: {
              width: '160px',
              border:
                (daten['info'][cardID]['telefon']?.length <= 7 ||
                  daten['info'][cardID]['ziffernfolge'] == 1 ||
                  daten['info'][cardID]['telefon'] == undefined) &&
                daten['info'][cardID]?.showerrors == 1
                  ? '1px solid red'
                  : '',
            },
            classes: {
              focused: classes.cssFocused,
              underline: classes.underline,
            },
          }}
          id="telefon"
          name="telefon"
          label="Telefon"
          value={
            daten['info'][cardID]['telefon']
              ? daten['info'][cardID]['telefon']
              : ''
          }
          InputLabelProps={{
            classes: {
              focused: classes.ccsLabelFocused,
            },
          }}
          onChange={e => handleChangeName(e, 'telefon')}
        ></TextField>
      </div>
    </div>
  );

  return (
    <div className="h-full flex flex-col justify-between ">
      <div className="text-center mt-40px">
        <Question questionNo={step} questionText={cardcontent['headline']} />
      </div>

      <div className="mx-auto">{renderObjekt}</div>

      <div className="h-40px"></div>
    </div>
  );
};

export default Namecard;
